import { Button, Menu, Portal, Spinner } from '@chakra-ui/react';
import { useEmailTemplates } from '../../hooks/useCommunications'
import type { EmailTemplateDto } from '../../types/communications'

interface TemplatePickerProps {
  /** Populates the parent's subject/body draft from the chosen template — this component owns
   * no draft state of its own, matching the compose page's single source of truth for the
   * subject/body inputs (spec §8: "Start from template ▾" populates subject+body). */
  onSelect: (subject: string, bodyMarkdown: string) => void
}

/** "Start from template ▾" dropdown (spec §8). Templates are committee-wide, not scoped to the
 * compose source, so this reads `useEmailTemplates()` (the full list) rather than anything
 * source-filtered. */
export function TemplatePicker({ onSelect }: TemplatePickerProps) {
  const { data: templates, isLoading } = useEmailTemplates()
  const hasTemplates = !!templates && templates.length > 0

  return (
    <Menu.Root positioning={{ placement: 'bottom-start' }}>
      <Menu.Trigger asChild>
        <Button size="sm" variant="outline" disabled={isLoading || !hasTemplates}>
          {isLoading && <Spinner size="xs" />}
          Start from template ▾
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {(templates ?? []).map((t: EmailTemplateDto) => (
              <Menu.Item
                key={t.id}
                value={t.id}
                onSelect={() => onSelect(t.subject, t.bodyMarkdown)}
              >
                {t.name}
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
}
